// extracted by mini-css-extract-plugin
export default {"locations-demo":"LocationsDemo_locations-demo__cEZv2","contacts-wrap":"LocationsDemo_contacts-wrap__GAX17"};